<template>
    <TintCategoryForm :tint_category="tint_category" v-if="loaded" :readOnly="false" />
</template>

<script>
import {BModal, BButton, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import TintCategoryForm from './TintCategoryForm.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    TintCategoryForm
  },
  data() {
    return {
      tint_category:null,
      loaded:false,
    }
  },
  methods:{
    
  },
  async mounted()
  {
    this.tint_category=await APIRequest.detail('tint-categories',this.$route.params.id)
    this.loaded=true
  }
}
</script>
